module.exports = __webpack_public_path__ + "static/bkg-label-goat-v2-587a8c629c7642f49f7dd8b66485c4f5.png";